import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mailSearch'
})
export class MailSearchPipe implements PipeTransform {

  transform(items: any[], searchText: string, keys: string[]): any[] {
    if (!items) return [];
    if (!searchText) return items;
    if (!keys || keys.length === 0) return items;

    const text = searchText.toLowerCase();

    return items.filter(item =>
      keys.some(key =>
        item[key] &&
        item[key].toString().toLowerCase().includes(text)
      )
    );
  }
}
